import { AnalyticsTab, CreditsNotesTab, InvoicesTab, OverviewTab, ResellerAgreementsTab, RevRecTab } from '../../../components';
import { AccountPermissionsActionsList } from '../../../types/generalTypes';
import { permissionCheck } from '../../../services/PermissionsMapping/PermissionsMapping.utils';
import store from '../../../store';

export enum SinglePartnerPageTabIndex {
	overview,
	ResellerAgreements,
	invoices,
	credits,
	analytics,
	revenueRecognition,
}

export const singlePartnerPageTabs = () => {
	const tabs = [
		{ title: 'overview', component: (prop?: any) => <OverviewTab {...prop} isPartner />, tabIndex: SinglePartnerPageTabIndex.overview },
		{ title: 'agreements', component: (prop?: any) => <ResellerAgreementsTab {...prop} />, tabIndex: SinglePartnerPageTabIndex.ResellerAgreements },

		{ title: 'invoices', component: (prop?: any) => <InvoicesTab {...prop} />, tabIndex: SinglePartnerPageTabIndex.invoices },
		{ title: 'credits', component: (prop?: any) => <CreditsNotesTab {...prop} />, tabIndex: SinglePartnerPageTabIndex.credits },
		{ title: 'analytics', component: (prop?: any) => <AnalyticsTab {...prop} />, tabIndex: SinglePartnerPageTabIndex.analytics },
	];

	if (permissionCheck(AccountPermissionsActionsList.VIEW_REV_REC, store.getState().user.permissions)) {
		tabs.push({ title: 'revenueRecognition', component: (prop?: any) => <RevRecTab {...prop} />, tabIndex: SinglePartnerPageTabIndex.revenueRecognition });
	}

	return tabs;
};

export const isTabHasTimeFilters = (tabIndex: number) => {
	switch (tabIndex) {
		case SinglePartnerPageTabIndex.overview:
		case SinglePartnerPageTabIndex.invoices:
		case SinglePartnerPageTabIndex.credits:
			return true;
		default:
			return false;
	}
};
